<template>
  <v-container>
    <v-form v-model="valid" ref="itemForm" @submit="item_submit">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-office-building</v-icon>
          Perfil Compañía
        </v-card-title>
        <v-card-text class="pt-3">
          <v-tabs v-model="activeTab" background-color="transparent" color="primary" grow>
            <v-tab>Información General</v-tab>
            <v-tab>Información Fiscal</v-tab>
            <v-tab>Configuración</v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- Pestaña de Información General -->
            <v-tab-item>
              <v-row class="mt-2">
                <v-col cols="12" md="3">
                  <v-select
                    v-model="item.typeid"
                    hide-details="auto"
                    label="Tipo Documento"
                    :items="setting['type_document_identifications']"
                    item-value="code"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-card-account-details"
                  />
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="item.PartyIdentification"
                    :rules="f_required"
                    label="ID"
                    hide-details="auto"
                    required
                    outlined
                    prepend-icon="mdi-identifier"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.PartyName"
                    label="Nombre"
                    hide-details="auto"
                    required
                    outlined
                    prepend-icon="mdi-domain"
                    :rules="f_required"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="item.economic_activity"
                    label="Actividad Económica"
                    hide-details="auto"
                    required
                    outlined
                    prepend-icon="mdi-briefcase"
                    :rules="f_required"
                    :items="commercialActivities"
                    item-text="name"
                    item-value="id"
                    hint="Seleccione la actividad económica correspondiente"
                    persistent-hint
                    clearable
                    return-object
                    @change="handleActivityChange"
                  >
                    <template v-slot:selection="{ item }">
                      <span>{{ item.id }} - {{ item.name }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          >{{ item.id }} - {{ item.name }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="item.AddressLine"
                    label="Dirección"
                    hide-details="auto"
                    required
                    outlined
                    prepend-icon="mdi-map-marker"
                    :rules="f_required"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.Department"
                    hide-details="auto"
                    label="Departamento"
                    :items="setting['departments']"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-map"
                    @change="filterCities"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.city_code"
                    hide-details="auto"
                    label="Ciudad"
                    :items="filteredCities"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-city"
                    :disabled="!item.Department"
                    @change="updateCityName"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.client_email"
                    id="name"
                    :rules="f_email"
                    label="Correo electrónico"
                    hide-details="auto"
                    required
                    outlined
                    prepend-icon="mdi-email"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.client_phone"
                    label="Teléfono"
                    hide-details="auto"
                    outlined
                    prepend-icon="mdi-phone"
                    :rules="f_phone"
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Pestaña de Información Fiscal -->
            <v-tab-item>
              <v-row class="mt-2">
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_organization_id"
                    hide-details="auto"
                    label="Tipo persona"
                    :items="setting['type_organizations']"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-account-group"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_regime_id"
                    hide-details="auto"
                    label="Tipo de régimen"
                    :items="setting['type_regimes']"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-cash-register"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.type_liability_id"
                    hide-details="auto"
                    label="Tipo de responsabilidad"
                    :items="setting['type_liabilities']"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-scale-balance"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="item.inc"
                    hide-details="auto"
                    label="Responsable del INC"
                    :items="inc"
                    item-value="id"
                    item-text="name"
                    outlined
                    required
                    prepend-icon="mdi-sync"
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Pestaña de Configuración -->
            <v-tab-item>
              <v-row class="mt-2">
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="item.store_code"
                    label="Cod. POSWEB"
                    hide-details="auto"
                    outlined
                    prepend-icon="mdi-barcode"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.sync_code"
                    hide-details="auto"
                    label="SYNC"
                    :items="lstSync"
                    item-value="id"
                    item-text="name"
                    outlined
                    required
                    prepend-icon="mdi-sync"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="item.environment"
                    hide-details="auto"
                    label="Ambiente"
                    :items="setting['type_environments']"
                    item-value="id"
                    item-text="name"
                    :rules="f_required"
                    outlined
                    required
                    prepend-icon="mdi-server"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="error" dark @click="dialog_confirm = true" :disabled="!item.id">
            <v-icon left>mdi-delete-outline</v-icon>
            Borrar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="success">
            <v-icon left>mdi-content-save-outline</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <!-- Dialogs -->
    <v-dialog persistent max-width="400" v-model="dialog_confirm">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="error">mdi-alert</v-icon>
          Confirmar eliminación
        </v-card-title>
        <v-card-text class="pa-4">
          ¿Está seguro que desea eliminar este registro? Esta acción no se puede deshacer.
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" @click="dialog_confirm = false"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="delete_item">
            <v-icon left>mdi-delete</v-icon>
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loading_status" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-title>
          {{ loadingStatus.title }}
        </v-card-title>
        <v-card-text class="pa-6">
          <p>{{ loadingStatus.text }}</p>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver, fe_ws } from "../services/webserver.js";
import createCompany from "../utils/createCompany.js";
import createSet from "../utils/createSetting.js";
import settings from "../utils/settings.js";

export default {
  name: "Company",
  components: {},
  beforeMount() {},
  mounted() {
    this.get_items();
  },
  data() {
    return {
      valid: false,
      activeTab: 0,
      loading_status: false,
      dialog_confirm: false,
      item: {
        ...createCompany(),
        economic_activity: null,
        CityName: "", // Asegurarnos de que CityName exista en el objeto
      },
      cityObj: createSet(),
      filteredCities: [],
      commercialActivities: [
        { id: "4711", name: "Tiendas de barrio (alimentos y bebidas)" },
        { id: "4719", name: "Tiendas mixtas no especializadas" },
        { id: "4771", name: "Almacenes de ropa y calzado" },
        { id: "4774", name: "Licoreras (venta para llevar)" },
        { id: "5610", name: "Restaurantes y cafeterías" },
        { id: "5630", name: "Bares y expendio de licor para consumo en sitio" },
      ],
      table_lst: [
        "countries",
        "type_document_identifications",
        "type_organizations",
        "type_regimes",
        "type_liabilities",
        "municipalities",
        "departments",
        "type_environments",
        "type_documents",
      ],
      lstSync: [
        { name: "TRUE", id: "1" },
        { name: "FALSE", id: "0" },
      ],
      inc: [
        { name: "Responsable del INC", id: "1" },
        { name: "FALSE", id: "0" },
      ],
      f_required: [(v) => !!v || "Campo requerido"],
      f_email: [
        (v) => !!v || "El correo es requerido",
        (v) => /.+@.+\..+/.test(v) || "Debe ingresar un correo válido",
      ],
      f_phone: [
        (v) => !v || /^\d{7,15}$/.test(v) || "Ingrese un número telefónico válido",
      ],
      reg_delete: null,
      loadingStatus: {
        title: "Procesando",
        text: "Conectando con la DIAN",
      },
      setting: settings(),
      snackbar: {
        show: false,
        text: "",
        color: "success",
        timeout: 3000,
      },
    };
  },
  methods: {
    filterCities() {
      console.log("Filtrando ciudades para departamento ID:", this.item.Department);

      if (
        this.item.Department &&
        this.setting.departments &&
        this.setting.municipalities
      ) {
        // Paso 1: Encontrar el departamento seleccionado usando su ID
        const selectedDept = this.setting.departments.find(
          (dept) => dept.id === this.item.Department
        );

        if (selectedDept && selectedDept.code) {
          // Paso 2: Obtener el código del departamento
          const deptCode = selectedDept.code;
          console.log("Código del departamento seleccionado:", deptCode);

          // Paso 3: Filtrar municipios cuyo código comience con el código del departamento
          this.filteredCities = this.setting.municipalities.filter((city) => {
            const cityCode = String(city.code);
            return cityCode.startsWith(deptCode);
          });

          console.log("Ciudades filtradas:", this.filteredCities.length);
        } else {
          console.log("No se encontró el departamento con ID:", this.item.Department);
          this.filteredCities = [];
        }
      } else {
        console.log("Faltan datos para filtrar ciudades");
        this.filteredCities = [];
      }

      // Resetear los campos de ciudad
      this.item.city_code = null;
      this.item.CityName = "";
    },

    updateCityName() {
      if (this.item.city_code && this.filteredCities.length > 0) {
        const selectedCity = this.filteredCities.find(
          (city) => city.id === this.item.city_code
        );
        if (selectedCity) {
          this.item.CityName = selectedCity.name;
          console.log("Ciudad seleccionada:", selectedCity.name);
        }
      }
    },

    showNotification(text, color = "success") {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    handleActivityChange(value) {
      // Asegurarnos de guardar el valor correcto en caso de que sea un objeto
      if (value && typeof value === "object" && value.id) {
        console.log("Activity selected:", value);
      }
    },

    item_submit(e) {
      e.preventDefault();
      this.valid = this.$refs.itemForm.validate();
      if (this.valid) {
        // Crear una copia del objeto para modificarlo antes de enviar
        const itemToSubmit = { ...this.item };

        // Si la actividad económica es un objeto, solo guardar el ID
        if (
          itemToSubmit.economic_activity &&
          typeof itemToSubmit.economic_activity === "object"
        ) {
          itemToSubmit.economic_activity = itemToSubmit.economic_activity.id;
        }

        // Asegurar que CityName esté establecido correctamente antes de enviar
        if (itemToSubmit.city_code && !itemToSubmit.CityName) {
          const selectedCity = this.filteredCities.find(
            (city) => city.id === itemToSubmit.city_code
          );
          if (selectedCity) {
            itemToSubmit.CityName = selectedCity.name;
          }
        }

        const qry = {
          store: window.store.store_id,
          table: "f_companies",
          data: [itemToSubmit],
        };

        this.loadingStatus = {
          title: "Procesando",
          text: "Actualizando registro...",
        };
        this.loading_status = true;
        webserver("put_dataTable", qry, (data) => {
          this.loading_status = false;
          console.log(data);
          this.showNotification("Información guardada correctamente");
        });
      } else {
        this.showNotification("Por favor complete todos los campos requeridos", "error");
      }
    },

    delete_itm(item) {
      this.reg_delete = item.id || item.code;
      this.dialog_confirm = true;
    },

    delete_item() {
      this.dialog_confirm = false;
      var record = this.reg_delete;
      this.loading_status = true;
      this.loadingStatus = {
        title: "Procesando",
        text: "Eliminando registro...",
      };
      var qry = {
        table: "f_company",
        filters: {
          account: this.$store.state.profile.account,
          code: record,
        },
      };
      console.log(qry);
      webserver("delete_record", qry, () => {
        this.reg_delete = null;
        this.loading_status = false;
        this.showNotification("Registro eliminado correctamente");
        this.item = {
          ...createCompany(),
          economic_activity: null,
          store_code: window.store.store_id,
          CityName: "", // Asegurar que CityName se resetea correctamente
        };
        this.$emit("refresh", true);
      });
    },

    GetSortOrder(prop) {
      return function (a, b) {
        if (a[prop] > b[prop]) {
          return 1;
        } else if (a[prop] < b[prop]) {
          return -1;
        }
        return 0;
      };
    },

    get_items() {
      var qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [
          {
            field: "store_code",
            operator: "=",
            value: window.store.store_id,
          },
        ],
      };
      this.loadingStatus = {
        title: "Procesando",
        text: "Obteniendo información...",
      };
      this.loading_status = true;
      webserver("get_dataTable", qry, (data) => {
        this.loading_status = false;
        this.item.store_code = window.store.store_id;
        if (data.length > 0) {
          console.log("get_dataTable>", data);

          let economicActivity = null;
          // Si hay actividad económica guardada, buscar el objeto correspondiente
          if (data[0].economic_activity) {
            economicActivity =
              this.commercialActivities.find(
                (activity) => activity.id === data[0].economic_activity
              ) || data[0].economic_activity;
          }

          this.item = {
            ...data[0],
            economic_activity: economicActivity,
          };
          this.cityObj = { name: data[0].CityName, code: data[0].city_code };

          // Initialize filtered cities based on current department
          if (this.item.Department) {
            this.filterCities();
            // Establecer el city_code después de filtrar las ciudades
            this.item.city_code = data[0].city_code;
          }
        }
      });
    },

    async get_settings() {
      this.itms = [];
      var qry = {};
      var tbl = "";
      this.loading_status = true;
      this.loadingStatus = {
        title: "Procesando",
        text: "Cargando configuraciones...",
      };

      for (tbl of this.table_lst) {
        if (tbl) {
          qry = {
            table: "settings",
            filters: [
              {
                field: "tableName",
                operator: "=",
                value: tbl,
              },
            ],
          };
          try {
            let promise = new Promise((resolve, reject) => {
              fe_ws(
                "get_table",
                qry,
                function (data) {
                  resolve(data);
                },
                function () {
                  reject([]);
                }
              );
            });

            var result = await promise;
            console.log(result);
            if (result) {
              result.sort(function (a, b) {
                return parseFloat(a.name) - parseFloat(b.name);
              });
              this.itms.push.apply(this.itms, result);
            }
          } catch (error) {
            console.error(`Error cargando tabla ${tbl}:`, error);
          }
        }
      }
      this.loading_status = false;
      var rstd = this.itms.reduce(function (rv, x) {
        (rv[x["tableName"]] = rv[x["tableName"]] || []).push(x);
        return rv;
      }, {});

      this.setting = rstd;
      this.get_items();
    },
  },
};
</script>

<style scoped>
.v-tabs {
  margin-bottom: 10px;
}
</style>
